import { render } from "./submission.vue?vue&type=template&id=0d68ef14&scoped=true&ts=true"
import script from "./submission.vue?vue&type=script&lang=ts"
export * from "./submission.vue?vue&type=script&lang=ts"

import "./submission.vue?vue&type=style&index=0&id=0d68ef14&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d68ef14"]])

export default __exports__